<template>
  <div class="cart">
    <table class="cart-items">
      <thead>
        <tr>
          <th class="first">Item Description</th>
          <th>Price</th>
          <th>Qty</th>
          <th class="last">Total</th>
        </tr>
      </thead>
      <tbody v-for="(item, index) in cartStore.itemsGetter" :key="item.id">
        <tr
          class="cart-item-row"
          :class="item.attributes.bundle_calculator ? 'no-border-bottom' : ''"
        >
          <td
            class="desc"
            :class="item.attributes.bundle_calculator ? 'no-border-bottom' : ''"
          >
            <div>
              <div
                v-if="
                  item.attributes.images &&
                  item.attributes.images.thumb !== null
                "
              >
                <img :src="item.attributes.images.thumb" alt="Product" />
              </div>
              <div v-else>
                <img
                  src="/images/retail-icon.png"
                  alt="Default Product Thumbnail"
                  class="img-responsive"
                />
              </div>
              <h5>
                {{ item.name }}
                {{ billingPeriodLong(item.attributes.billing_period) }}
              </h5>
            </div>
          </td>
          <td
            class="price"
            :class="item.attributes.bundle_calculator ? 'no-border-bottom' : ''"
          >
            ${{
              item.attributes.bundle_calculator
                ? item.attributes.price
                : item.price
            }}
            {{ billingPeriodShort(item.attributes.billing_period) }}
          </td>
          <td
            class="qty"
            :class="item.attributes.bundle_calculator ? 'no-border-bottom' : ''"
          >
            <input
              v-model="item.quantity"
              name="qty-item1"
              type="number"
              min="1"
              :max="isItemTypeSingular(item.attributes.type) ? 1 : 999"
              :disabled="isItemTypeSingular(item.attributes.type)"
              class="qty-input"
              @keyup.enter="enterMethod($event.target)"
              @blur="cartStore.updateItemQty(item.id, item.quantity)"
            />
            <br />
            <a
              href="javascript:void(0)"
              class="pulled-element remove-from-cart"
              @click.prevent="cartStore.removeItem(item.id)"
            >
              Remove
            </a>
          </td>
          <td
            class="total"
            :class="item.attributes.bundle_calculator ? 'no-border-bottom' : ''"
          >
            {{
              item.attributes.bundle_calculator
                ? item.attributes.bundle_calculator
                    .bundle_cost_to_farthest_expiration
                : individualItemPriceAdjustment(item.price, item.quantity)
            }}
          </td>
        </tr>
        <template v-if="item.attributes.bundle_calculator">
          <tr class="cart-item-row">
            <td class="desc no-border-top">
              <div class="cart-flex">
                <div class="left-spacer"></div>
                <h5>Discount - Existing Subscription Prorate</h5>
              </div>
            </td>
            <td class="price no-border-top"></td>
            <td class="qty no-border-top"></td>
            <td class="total no-border-top">
              -${{
                item.attributes.bundle_calculator.prorated_discount.toFixed(2)
              }}
            </td>
          </tr>
        </template>
      </tbody>
      <tbody>
        <tr class="cart-item-row total-row">
          <td>
            <!-- <p class="store-notes">Need help? Talk to our staff about your needs. Call (603) 743-5777<br>*No refunds or returns on subscription products</p> -->
          </td>
          <td class="price">&nbsp;</td>
          <td class="qty">Total</td>
          <td class="total">
            {{ cartStore.formattedTotal }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="cart-buttons">
      <a :href="_storeurl" class="button-grey">Continue Shopping</a>
      <a :href="_checkouturl" class="button-green">Checkout</a>
    </div>
  </div>
</template>

<script>
  import { useCartStore } from '~/stores/cart';

  export default {
    props: {
      _checkouturl: {
        type: String,
        required: true,
      },
      _storeurl: {
        type: String,
        required: true,
      },
    }, 
    setup() {
      const cartStore = useCartStore();
      return { cartStore };
    },
    methods: {
      isItemTypeSingular(type) {
        return (
          type === 'Subscription' || type === 'Webinar' || type === 'Invoice'
        );
      },
      //helpers
      billingPeriodShort(billingPeriod) {
        switch (billingPeriod) {
          case 'monthly':
            return '/Mo';
          case 'annually':
            return '/yr';
          default:
            return '';
        }
      },
      billingPeriodLong(billingPeriod) {
        switch (billingPeriod) {
          case 'monthly':
            return '(Monthly Subscription) *';
          case 'annually':
            return '(Annual Subscription) *';
          default:
            return '';
        }
      },
      individualItemPriceAdjustment(price, qty) {
        const totaltemp = price * qty;
        return totaltemp.toFixed(2);
      },
      enterMethod: function (value) {
        value.blur();
      },
    },
  };
</script>
<style scoped lang="scss">
  .no-border-bottom {
    border-bottom: none !important;
  }
  .no-border-top {
    border-top: none !important;
  }
  .cart-flex {
    display: flex;
  }
  .left-spacer {
    height: 20px;
    width: 165px;
    margin-right: 30px;
  }
</style>
